<template>
  <div class="">
    <sticky class="page-header sticky-page-header page-header--new"
            :back-button="true"
            :bigTotal="bigTotal"
            :loading="loading" :total="bigTotal"
            :label="'Société'">
      <router-link v-if="!isSectorManager" :to="{name: 'CompanyCreate'}" class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fas fa-plus-circle"></i></span>
        <span>Créer Société</span>
      </router-link>
      <a @click="loadItems()" class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fas fa-sync"></i></span>
        <span>Actualiser données</span>
      </a>
    </sticky>
    <spinner-round :isLoading="loading" v-if="loading"></spinner-round>
    <div class="page-content columns collapseColumn collapseColumn--left collapseColumn--alignStart"
      id="columns-collapse"
      :class="opened ? 'is-active-collapse' : 'is-inactive-collapse'"
    >
      <div class="column is-4 is-3-widescreen is-3-fullhd">
        <list-filter @resetFilters="resetFilters"
                     @changeFilters="changeFilters"
                     :total="total"
                     :bigTotal="bigTotal"
                     :loading="loading"
                     :hasFilter="hasFilter"
                     @opened="opened = !opened">
          <div class="columns">
            <div class="column is-padding-top-small is-paddingless-bottom">
              <div class="control">
                <input @input="inputChange" v-model="filters.name" class="input"
                        type="text" placeholder="Nom de la société">
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-padding-top-small is-paddingless-bottom">
              <div class="control">
                <input @input="inputChange" v-model="filters.siret" class="input"
                        type="text" placeholder="Siret">
              </div>
            </div>
          </div>
          <div class="columns is-paddingless-bottom" v-if="displayRemuneration">
            <div class="column is-padding-top-small">
              <range-chooser formatter="{value} %"
                             @change="updateRemunerationFilter"
                             :re-render="opened"
                             :custom-labels="['0', '3', '6', '9', '12', '15']"
                             :max="15"
                             :label="'Rémunération min / max'"
                             :is-slider="true"
                             :step="0.5"
                             :model="[filters.remuneration__gte, filters.remuneration__lte]">
              </range-chooser>
            </div>
          </div>
        </list-filter>
      </div>
      <div class="column is-8 is-9-widescreen is-9-fullhd is-overflow-auto">
        <div class="is-border">
          <div class="columns is-gapless row-width-actions-bar is-border-bottom">
            <transition enter-active-class="animated fadeIn faster" leave-active-class="animated fadeOut faster" mode="out-in">
              <div class="column is-narrow has-bg-primary columns is-vcentered is-gapless" v-if="hasFilter && !loading && total !== bigTotal">
                <div class="column is-padding-left is-padding-right has-text-white">Résultat : {{total || 0}} société(s)</div>
              </div>
            </transition>
            <div class="column"></div>
            <div class="column is-narrow">
              <button class="page-header-btn is-square is-static is-ghost">
                <span class="icon"><i class="fas fa-sort-amount-upXX"></i></span>
              </button>
            </div>
          </div>
          <div class="column is-narrow is-padding-top-small is-padding-bottom-small" v-if="isAdmin">
            <label class="checkbox checkRadioIsHide is-padding-right-xsmall" :for="s.value" v-for="s in activationStatus" :key="s.value">
              <input type="checkbox" :id="s.value" @click="updateDisabledFilter(s)" :value="s.value">
              <span class="tag is-margin-bottom-xsmall" :class="s.color">
                <span>{{s.label}}</span>
                <span class="icon"><i class="far" :class="filters.disabled === s.value ? 'fa-check-square' : 'fa-square'"></i></span>
              </span>
            </label>
          </div>
          <div class="is-padding" v-if="hasFilter && !loading">
            <label for="" class="is-size-6 label is-padding-bottom-small">Vos critères de recherche :</label>
            <div class="tags">
              <span class="tag is-primary is-rounded" v-if="filters.name" >
                    {{filters.name}} <a @click="deleteFilter('name')" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.siret" >
                    {{filters.siret}} <a @click="deleteFilter('siret')" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.remuneration__gte">
                &gt; {{filters.remuneration__gte}}% <a @click="deleteFilter('remuneration__gte')" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.remuneration__lte">
                &lt; {{filters.remuneration__lte}}% <a @click="deleteFilter('remuneration__lte')" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-annonce is-rounded has-cursor-pointer" @click="resetFilters">
                Réinitialiser les filtres <span class="icon is-white is-margin-left-xsmall"><i class="fas fa-undo"></i></span>
              </span>
            </div>
          </div>
          <div>
            <table-h-scroll :has-sticky="true" :sticky-styles="stickyStyles"
                          :sticky-datas="stickyDatas" :reload-controls="loading && items.length">
              <table v-show="!loading && items.length" class="table is-fullwidth is-narrow is-first-fixed-small is-marginless-bottom has-actionsontd">
                <thead>
                <tr class="is-size-6">
                  <th></th>
                  <th>
                    <sortable @sort="sort('name', $event)" :sort="sortBy.name" label="Nom Société"></sortable>
                  </th>
                  <th>
                    <sortable @sort="sort('user_count', $event)" :sort="sortBy.user_count" label="Membres"></sortable>
                  </th>
                  <th v-if="displayRemuneration">
                    <sortable @sort="sort('remuneration', $event)" :sort="sortBy.remuneration"
                              label="Taux rémunération"></sortable>
                  </th>
                  <th class="has-text-centered is-narrow">Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(company, index) in items" :key="company.pk" class="is-size-6" :id="'e' + company.pk" :class="{'has-status-bar--left has-status-bar--draft':scrollToEl === company.pk}">
                  <td  class="has-text-centered">
                    <span v-if="isAdmin || isSectorManager" class="dot tooltip is-tooltip-right" :class="company.disabled ? 'has-bg-danger' : 'has-bg-success'"
                          :data-tooltip="company.disabled ? 'Désactivé' : 'Actif'"></span>
                    <span v-else></span>
                  </td>
                  <td class="is-cell-hoverable">
                    <router-link :to="{name: 'CompanyVue', params: {id: company.pk}, query: {returnId: company.pk, page: currentPage}}">{{company.name}}</router-link>
                  </td>
                  <td>
                    <span>{{company.user_count}}</span>
                  </td>
                  <td v-if="displayRemuneration">
                    <span v-if="company.remuneration">{{company.remuneration | prettyPrice}} %</span>
                    <span v-else>--</span>
                  </td>
                  <td class="has-text-centered actions">
                    <display-button-list :buttons="buttonList" :data="company"
                      :openUp="{'position': index, 'total': items.length}">
                    </display-button-list>
                  </td>
                </tr>
                </tbody>
                <tr class="empty empty--row" v-for="n in items.length < 8 ? 8 - items.length : 0 " :key="n"><td class="is-borderless"></td></tr>
              </table>
            </table-h-scroll>
            <div class="is-border-top" v-if="totalPage > 1 && nextPage && !loading">
              <a class="button is-light is-fullwidth has-text-grey" @click="loadMore(true)" v-if="!infiniteLoading">
                <span class="icon is-small is-size-6"><i class="fas fa-chevron-down"></i></span>
                <span class="is-size-6">Afficher la suite</span>
              </a>
              <div class="has-text-centered" v-else><img src="static/spinner2.svg" alt="spinner" style="height: 38px"></div>
            </div>
            <div v-show="!loading && !items.length">
              <div class="columns">
                <div class="column">
                  <h2 class="title is-3 has-text-weight-bold">Aucune Société disponible</h2>
                  <a class="has-text-primary" @click="resetFilters" v-if="hasFilter"><span class="icon is-small"><i
                    class="fal fa-undo-alt"></i></span> <span>Réinitialiser les filtres</span></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { GenericList, Sort, Filter, TableHeaderSticky } from '../../mixins'
  import { debounce } from 'lodash'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'CompanyList',
    mixins: [GenericList, Sort, Filter, TableHeaderSticky],
    data () {
      return {
        buttonList: [
          {
            action: (id) => {
              let actionId = id
              this.$router.push({name: 'CompanyVue', params: {id: actionId}, query: {returnId: actionId, page: this.currentPage}})
            },
            icon: 'fas fa-file-invoice',
            text: 'Fiche société'
          },
          {
            action: (id) => {
              let actionId = id
              this.$router.push({name: 'CompanyEdit', params: {id: actionId}, query: {returnId: actionId, page: this.currentPage}})
            },
            icon: 'fas fa-edit',
            text: 'Modifier fiche société',
            needProfile: ['admin']
          },
          {
            action: (id) => {
              this.deleteItem(id)
            },
            icon: 'fas fa-trash-alt',
            text: 'Supprimer société',
            needProfile: ['admin']
          }
        ],
        loadDocuments: this.loadItems,
        service: this.$api.companyService,
        itemName: 'société',
        filters: {
          disabled: 0
        },
        initFilters: {
          disabled: 0
        },
        opened: true,
        infiniteLoaderEnabled: true,
        activationStatus: [
          {value: 0, label: 'Actif', color: 'is-success'},
          {value: 1, label: 'Désactivé', color: 'is-danger'}
        ]
      }
    },
    computed: {
      ...mapState(['scrollToEl', 'scrollToPage']),
      ...mapGetters(['isAdmin', 'isManager', 'displayRemuneration', 'isSectorManager'])
    },
    methods: {
      deleteFilter (key) {
        this.$set(this.filters, key, null)
        delete this.filters[key]
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      updateDisabledFilter (e) {
        this.$set(this.filters, 'disabled', e.value)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      updateRemunerationFilter: debounce(function (e) {
        if (e[0] !== this.filters.remuneration__gte || e[1] !== this.filters.remuneration__lte) {
          this.$set(this.filters, 'remuneration__gte', e[0])
          this.$set(this.filters, 'remuneration__lte', e[1])
          this.$nextTick(() => {
            this.changeFilters()
          })
        }
      }, 500),
      updateSellerFilter (e) {
        this.$nextTick(() => {
          this.changeFilters()
        })
      }
    },
    created () {
      this.$nextTick(() => {
        this.filters.disabled = 0
        this.changeFilters()
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/company/CompanyList.vue